var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEEE5",
    fillRule: "nonzero",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.389 30.207V46.82c0 2.524-2.056 4.57-4.589 4.57H28.506c-2.534 0-4.588-2.046-4.588-4.57V25.486c0-2.525 2.054-4.571 4.588-4.571h10.555c.812 0 1.589.32 2.162.891l6.27 6.246c.573.572.896 1.347.896 2.155z",
    fill: "#FFBF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 34.629h10.706M30.8 41.359h10.706",
    stroke: "#FF6D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/ic_file.61a3ccd5735c26c46253f8b20b5db8c3.svg";
export { ForwardRef as ReactComponent };